/**
 * Helper methods to manage/monitor the state of the iframe's resize mechanism.
 * This useful to manage the timing between resize and scroll events for example
 * */

function isAppIframed () {
    return 'parentIFrame' in window;
}

function setIframeIsResizing () {
    window.iframeIsResizing = true; // a flag that is used to control the timing of 'resize' and 'scroll' events when the app is iframed
}

function isIframeResizing () {
    return 'iframeIsResizing' in window;
}

function resetIframeIsResizing () {
    delete window.iframeIsResizing;
}

export default {
    isAppIframed,
    setIframeIsResizing,
    isIframeResizing,
    resetIframeIsResizing,
};
